import { createSlot } from '@ayocore/platform/client/extensions/createSlot';

/**
 * Точки расширения реестра платежей (SupplierInvoicesList).
 *
 * Позволяют инстансу настроить реестр под свой процесс, не форкая компонент.
 */
export const SupplierInvoiceListExtensions = {
  /**
   * Скрыть кнопку «Создать счёт» в реестре.
   *
   * Нужна инстансам, где счёт заводится только из карточки закупки
   * (technoalliance): свободные счета там — мусор, который некому привязать.
   * Инстансы, где счёт создают в реестре и потом привязывают к сделке
   * (grasias), обработчик не регистрируют и кнопку сохраняют.
   *
   * @example
   * // instances/technoalliance/client/bootstrap.ts
   * SupplierInvoiceListExtensions.hideStandaloneCreate.register(() => true);
   */
  hideStandaloneCreate: createSlot<void, boolean>(),
  /**
   * Запретить прошлые даты оплаты при создании счёта.
   *
   * Настройка читается самой SupplierInvoiceForm, поэтому действует одинаково
   * для реестра, карточки сделки и заказа на закупку.
   */
  disallowPastPaymentDates: createSlot<void, boolean>(),
  /**
   * Разрешить править реквизиты счёта после отправки на оплату.
   *
   * Серверная политика инстанса всё равно является источником истины; слот
   * только снимает блокировку полей общей формы.
   */
  allowEditingAfterSend: createSlot<void, boolean>(),
};
